import { render, staticRenderFns } from "./ClientPreferenceResults.vue?vue&type=template&id=9629e1ce&scoped=true&"
import script from "./ClientPreferenceResults.vue?vue&type=script&lang=js&"
export * from "./ClientPreferenceResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9629e1ce",
  null
  
)

export default component.exports